module.exports = __webpack_public_path__ + "img/cover-fiat-smartrace-autoshow.b4a293ea.jpg";